import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import RazorpayPayment from "./pages/RazorpayPayment";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import ContactPage from "./pages/ContactPage";
import Services from "./pages/Services";
import Domain from "./pages/Domain";
import Seo from "./pages/Seo";
import Hosting from "./pages/Hosting";
import Ssl from "./pages/Ssl";
import Email from "./pages/Email";
import MobileAppDevelopments from "./pages/MobileAppDevelopments";
import Ppc from "./pages/PPC";
import ExistingProjectsUpdates from "./pages/ExistingProjectsUpdates";
import PaymentSuccess from "./pages/PaymentSuccess";
import MyMailboxes from "./pages/MyMailboxes";
import MyDomains from "./pages/MyDomains";
import ManageDns from "./pages/ManageDns";
function AppRoutes() {
  // No Italian language logic needed

  return (
<div className="min-h-screen bg-gray-100 pt-[110px] md:pt-[125px]">
          <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/domain" element={<Domain />} />
        <Route path="/seo" element={<Seo />} />
        <Route path="/hosting" element={<Hosting />} />
        <Route path="/ssl" element={<Ssl />} />
        <Route path="/email" element={<Email />} />
        <Route path="/ppc" element={<Ppc />} />

<Route
  path="/existing-projects-updates"
  element={<ExistingProjectsUpdates />}
/>
        <Route path="/mobile-app-developments" element={<MobileAppDevelopments />} />
        <Route
          path="/payment/razorpay"
          element={
            <ProtectedRoute>
              <RazorpayPayment locale="en" />
            </ProtectedRoute>
          }
        />
        <Route
  path="/payment-success"
  element={<PaymentSuccess />}
/>
        <Route
          path="/my-mailboxes"
          element={
            <ProtectedRoute>
              <MyMailboxes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-domains"
          element={
            <ProtectedRoute>
              <MyDomains />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-domains/:id/dns"
          element={
            <ProtectedRoute>
              <ManageDns />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment/stripe"
          element={
            <ProtectedRoute>
              {/* <StripePayment locale="en" /> */}
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
